// Build a WhatsApp share URL (wa.me) with a friendly Spanish message about a deadline
// The URL opens WhatsApp letting the user pick a contact/group before sending.
const APP_NAME = 'Vida en Orden';

function formatAmount(amount, currency) {
  if (amount === null || amount === undefined || amount === '') return null;
  const cur = currency || '$';
  const num = typeof amount === 'number' ? amount : Number(amount);
  if (Number.isNaN(num)) return `${cur} ${amount}`;
  return `${cur} ${num.toLocaleString('es-AR')}`;
}

function formatDate(date) {
  if (!date) return null;
  const d = new Date(date);
  if (Number.isNaN(d.getTime())) return date;
  return d.toLocaleDateString('es-AR', { day: '2-digit', month: 'long', year: 'numeric' });
}

export function buildWhatsAppMessage({ title, date, description, amount, currency, kind = 'reminder' }) {
  const parts = [];
  const emoji = kind === 'task' ? '📋 Tarea' : kind === 'bill' ? '🧾 Vencimiento' : '⏰ Recordatorio';
  parts.push(`${emoji}: ${title}`);

  const dateStr = formatDate(date);
  if (dateStr) parts.push(`📅 ${dateStr}`);

  const amountStr = formatAmount(amount, currency);
  if (amountStr) parts.push(`💰 ${amountStr}`);

  if (description) parts.push(`📝 ${description}`);

  parts.push('');
  parts.push(`— ${APP_NAME}`);

  return parts.join('\n');
}

export function shareViaWhatsApp(payload) {
  const text = buildWhatsAppMessage(payload);
  const url = `https://wa.me/?text=${encodeURIComponent(text)}`;
  window.open(url, '_blank', 'noopener,noreferrer');
}
